module.exports = __webpack_public_path__ + "static/media/careers-picture2.aa7f2199.jpg";